/**
 * Adresa backendu pre administráciu. Pri vývoji http://localhost:3000.
 * Pre ostrú prevádzku nastavte pred zostavením v .env.production:
 *   VITE_API_URL=https://api.cukrarenemili.sk
 */
export const API = String(import.meta.env.VITE_API_URL || 'http://localhost:3000').replace(/\/+$/, '')

/**
 * Adresa e-shopu pre náhľad vo vizuálnom editore. Pri vývoji http://localhost:5174.
 * Pre ostrú prevádzku nastavte v .env.production:  VITE_SHOP_URL=https://www.cukrarenemili.sk
 */
export const SHOP_URL = String(import.meta.env.VITE_SHOP_URL || 'http://localhost:5174').replace(/\/+$/, '')
